import BackButton from "../GoBack/GoBack";
import "../Profile/Profile.css";
import "./ProgressTracker.css";
import { StudentMapMenu } from "../Map/MapMenu/MapMenu";
import TopImage from "../../common/TopImage";
import classroomImg from "../../../../assets/img/progress.png";
import { SideDesign } from "../../common/SideDesign";
import { ProgressTableCard } from "./ProgressTableCard";
import { useEffect } from "react";
import { useGetSclStudentProgress } from "../../../../hooks/student/useGetStudentProgress";
import { SchlStudentProgressSkeleton } from "./ProgressSkeleton";

export const SchlStudentProgressTracker = () => {
  const { progressData, loading, error, getStudentProgress } =
    useGetSclStudentProgress();

  useEffect(() => {
    getStudentProgress();
  }, []);

  if (loading) return <SchlStudentProgressSkeleton />;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <section>
      <div className="container-fluid">
        <div className="teacher-bodycontent">
          <div className="mb-4">
            <BackButton />
          </div>

          <TopImage
            imageSrc={classroomImg}
            text="Progress Tracker"
            subText="Your Journey Through Learning"
          />

          <div className="ProgressContainer row mt-4">
            {/* OVERALL PROGRESS CARD */}
            <div className="col-md-12">
              <div
                className="mx-auto mb-4"
                style={{
                  borderRadius: "14px",
                  border: "1px solid #D2D2D2",
                  position: "relative",
                  padding: "28px 28px",
                  maxWidth: "100%",
                }}
              >
                {/* TOP CHIP */}
                <div className="position-absolute text-center top-0 start-50 translate-middle-x text-white ProgressTitleBar">
                  Overall Progress %
                </div>

                <div className="row align-items-center mt-3">
                  <div className="col-md-5 text-center">
                    <span
                      className="fw-bold"
                      style={{ fontSize: "72px", color: "#0037AC" }}
                    >
                      {progressData?.progress?.overall_percentage || "0"}%
                    </span>
                  </div>

                  <div className="col-md-1 d-none d-md-flex justify-content-center">
                    <div
                      style={{
                        width: "2px",
                        height: "80px",
                        background: "#D2D2D2",
                      }}
                    />
                  </div>

                  <div className="col-md-5 text-center">
                    <div className="" style={{ fontSize: "16px" }}>
                      You’re making great progress this semester.
                    </div>
                    <div className="pt-2" style={{ fontSize: "14px" }}>
                      Keep it up!
                    </div>
                  </div>
                  <div className="col-md-1"></div>
                </div>
              </div>
            </div>

            <ProgressTableCard
              title="Lesson: Ancient Characters"
              quests={progressData?.progress?.quests || []}
            />
          </div>

          {/* Side Design Images */}
          <SideDesign />

          {/* <StudentFooter /> */}
          <StudentMapMenu />
        </div>
      </div>
    </section>
  );
};
